import { render, staticRenderFns } from "./Family-statement-template-list.vue?vue&type=template&id=32e515ae"
import script from "./Family-statement-template-list.vue?vue&type=script&lang=js"
export * from "./Family-statement-template-list.vue?vue&type=script&lang=js"
import style0 from "./Family-statement-template-list.vue?vue&type=style&index=0&id=32e515ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports